import Vue from 'vue';
import Vuex from 'vuex';
import checkOutModule from './checkout/checkOutModule';
import addressBookModule from './addressBook/addressBookModule';
import authModule from './auth/authModule';
import configuratorModule from './configurator/configuratorModule';
import homeModule from './home/homeModule';

Vue.use(Vuex);
/**
 * enable devtools in the store
 * @link https://github.com/vuejs/vue-devtools#force-enable-the-devtools
 */
Vue.config.devtools =
  process.env.VUE_APP_ENV === 'local' || process.env.VUE_APP_ENV === 'staging';

export const store = new Vuex.Store({
  modules: {
    authModule,
    checkOutModule,
    addressBookModule,
    configuratorModule,
    homeModule
  }
});
